import React from "react";
import { Box, CardContent, Skeleton } from "@mui/material";
import { StandardCard } from "../../../../components/Cards";

export const BarGraphSkeleton: React.FC = () => {
  return (
    <StandardCard>
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1 }} />
          <Skeleton variant="text" width={200} height={32} />
        </Box>
        <Box sx={{ height: 300, mt: 2 }}>
          <Skeleton variant="rectangular" width="100%" height="100%" />
        </Box>
      </CardContent>
    </StandardCard>
  );
};
